import * as React from "react";
import { useHistory } from "react-router-dom";

import { ActionButton } from "src/library/components/Button";

import { BranchWastageGrouped } from "../../api/waste.api";

interface BranchWastageGroupedActionListProps {
  waste: BranchWastageGrouped
}

export const BranchWastageGroupedActionList: React.ReactFCWithChildren<BranchWastageGroupedActionListProps> = ({ waste }) => {
  const history = useHistory();

  const actionButtonItems = [
    {
      title: "View waste",
      action: () => {
        history.push("/waste/report-wastage", { wasteDate: waste.wasteDate });
      }
    }
  ];

  return (
    <ActionButton
      title="Waste actions"
      items={actionButtonItems}
      disabled={actionButtonItems.length === 0}
    />
  );
};
